/**
 *
 * @param {moment.Moment} nightDiffStart
 * @param {moment.Moment} nightDiffEnd
 * @param {moment.Moment} shiftStart
 * @param {moment.Moment} shiftEnd
 * @returns {Number}
 */
function calculateNightDifferential(
  nightDiffStart,
  nightDiffEnd,
  shiftStart,
  shiftEnd
) {
  const nightStartHour = nightDiffStart.hour();
  const nightEndHour = nightDiffEnd.hour();

  const startHour = shiftStart.hour();
  const startMinute = shiftStart.minute();

  const endHour = shiftEnd.hour();
  const endMinute = shiftEnd.minute();

  // Calculate the total hours and minutes worked
  let totalHours =
    endHour < startHour ? 24 - startHour + endHour : endHour - startHour;

  // Calculate the night differential minutes
  let nightDiffMins = 0;

  if (startHour >= nightStartHour && startMinute > 0)
    nightDiffMins -= startMinute;

  // Loop through each hour and minute of work and check if it falls within the nighttime hours
  for (let i = startHour; i < startHour + totalHours; i++) {
    const currentHour = i % 24;

    if (currentHour >= nightStartHour || currentHour < nightEndHour)
      nightDiffMins += 60;
  }

  if ((endHour > nightStartHour || endHour < nightEndHour) && endMinute > 0)
    nightDiffMins += endMinute;

  return nightDiffMins;
}

export default calculateNightDifferential;
